// Regex to extra host name from a URL
const HOSTNAME_REGEX = new RegExp('^https?://([^/]*)/.*', 'i');

// Current window host name
const CURRENT_HOSTNAME = window.location.hostname.toLowerCase();

/**
 * Check if url is cross domain as OWA host or same by running a regex match on URL against OWA host
 * @param url the url to check
 */
export function isCrossDomain(url: string): boolean {
    const matches = url.match(HOSTNAME_REGEX);
    return matches != null && matches.length > 1 && matches[1].toLowerCase() != CURRENT_HOSTNAME;
}

/**
 * Get host name from a given url
 * @param url the url to check
 */
export function getHostNameFromUrl(url: string) {
    const matches = url.match(HOSTNAME_REGEX);
    return matches != null && matches.length > 1 ? matches[1].toLowerCase() : CURRENT_HOSTNAME;
}

/**
 * Get current host name
 */
export function getCurrentHostName() {
    return CURRENT_HOSTNAME;
}
